import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { KeyValue } from '@angular/common';

export interface RelationshipSubmissionDetails {
  displayString?: string;
  data?: KeyValue<string, string>[];
}

@Component({
  selector: 'app-relationship-status-submission-detail-grouping',
  templateUrl: './relationship-status-submission-detail-grouping.component.html',
  styleUrls: ['./relationship-status-submission-detail-grouping.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RelationshipStatusSubmissionDetailGroupingComponent {
  @Input() previousDetails!: RelationshipSubmissionDetails;
  @Input() newDetails!: RelationshipSubmissionDetails;
}
